module.exports = __webpack_public_path__ + "static/media/logo-big.2cb93840.svg";